<nav class="navbar navbar-expand-lg navbar-dark bg-dark mgp-navbar">
    <a class="navbar-brand" routerLink="/" (click)="collapseNavbar()"         data-toggle="tooltip"
    title="{{appVersion}}" >Modulo Gestione Progetto</a>
    <a
        class="navbar-toggler d-lg-none"
        href="javascript:void(0);"
        data-toggle="collapse"
        data-target="#navbarResponsive"
        aria-controls="navbarResponsive"
        aria-expanded="false"
        aria-label="Toggle navigation"
        (click)="toggleNavbar()"
    >
        <fa-icon icon="bars"></fa-icon>
    </a>
    <div class="collapse navbar-collapse" id="navbarResponsive"  [ngbCollapse]="isNavbarCollapsed">
        <ul class="navbar-nav me-auto">
            <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <a class="nav-link" routerLink="/" (click)="collapseNavbar()">
                    <span>
                        Home
                    </span>
                </a>
            </li>
            <ng-container *ngIf="!isAdmin">
                <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a class="nav-link" routerLink="/progetti" routerLinkActive="active" (click)="collapseNavbar()" data-cy="projects">
                        <span>
                            Lista progetti
                        </span>
                    </a>
                </li>
                <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a class="nav-link" routerLink="/progetti/nuovo" (click)="collapseNavbar()" data-cy="projectsNew">
                        <span>
                            Nuovo progetto
                        </span>
                    </a>
                </li>
                <!-- Jira 1289
                    Feauture to delegate-->
                <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngIf="isReferent">
                    <a class="nav-link" routerLink="/deleghe" (click)="collapseNavbar()" data-cy="delegation">
                        <span>
                            Deleghe
                        </span>
                    </a>
                </li>
                <!-- Jira 1289--> 
                <!-- Jira 1502
                    Feauture to archive projects-->
                <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngIf="isReferent">
                    <a class="nav-link" routerLink="/archiviazione" (click)="collapseNavbar()" data-cy="archiving">
                        <span>
                            Archiviazione progetti
                        </span>
                    </a>
                </li>
                <!-- Jira 1502--> 


                <!-- Feature only for Admin
                    li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a class="nav-link" routerLink="/progetti-gitops" routerLinkActive="active" (click)="collapseNavbar()" data-cy="projects">
                        <span>
                            Lista progetti GitOps
                        </span>
                    </a>
                </li>
                <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a class="nav-link" routerLink="/progetti-gitops/nuovo" (click)="collapseNavbar()" data-cy="projectsNew">
                        <span>
                            Nuovo progetto GitOps
                        </span>
                    </a>
                </li-->
            </ng-container>
            <ng-container *ngIf="isAdmin">
                <li ngbDropdown
                    class="nav-item dropdown pointer"
                    display="dynamic"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">
                    
                    <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="admin-menu" data-cy="adminMenu">
                        <span>Amministratore</span>
                    </a>
                    <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="admin-menu">
                        <li>
                            <a class="dropdown-item" routerLink="/admin/utenti" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()" data-cy="adminProjects">
                            <span>Utenti amministrativi</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="/admin/progetti" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()" data-cy="adminProjects">
                            <span>Lista progetti</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="/admin/progetti-gitops" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()" data-cy="adminProjects">
                            <span>Lista progetti AppOfApps</span>
                            </a>
                        </li>
                        <!-- Jira 1336 -->
                        <li>
                            <a class="dropdown-item" routerLink="/admin/progetti-cfg" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()" data-cy="adminProjects">
                            <span>Creazione progetti Cfg</span>
                            </a>
                        </li>
                        <!-- Jira 1336 -->
                        <!-- Jira 1502 -->
                        <li>
                            <a class="dropdown-item" routerLink="/admin/archiviazione" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()" data-cy="adminProjects">
                            <span>Archiviazione progetti</span>
                            </a>
                        </li>
                        <!-- Jira 1502 -->
                        <!-- Jira 1555 -->
                        <li>
                            <a class="dropdown-item" routerLink="/admin/aggiornamento" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="collapseNavbar()" data-cy="adminProjects">
                            <span>Aggiornamento referente di progetto</span>
                            </a>
                        </li>
                        <!-- Jira 1555 -->  
                        <li>
                            <a class="dropdown-item" routerLink="/admin/news" routerLinkActive="active" (click)="collapseNavbar()" data-cy="adminNews">
                            <span>News</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="/admin/enti" routerLinkActive="active" (click)="collapseNavbar()" data-cy="adminAgency">
                            <span>Enti</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="/admin/referenti-settori" routerLinkActive="active" (click)="collapseNavbar()" data-cy="adminReferentScope">
                            <span>Coppia Referenti-Settori</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="/admin/tipologie-app" routerLinkActive="active" (click)="collapseNavbar()" data-cy="adminAppType">
                            <span>Tipologie di applicazione</span>
                            </a>
                        </li>
                        <!-- Jira 1207
                        Feauture to associate AppOfApps Registries to Referents-->
                        <li>
                            <a class="dropdown-item" routerLink="/admin/referenti-registri" routerLinkActive="active" (click)="collapseNavbar()" data-cy="adminReferentRegistry">
                            <span>Coppia Referenti-Registri</span>
                            </a>
                        </li>
                        <!-- Jira 1207-->                        
                        <li>
                            <a class="dropdown-item" routerLink="/admin/metodi-rilascio" routerLinkActive="active" (click)="collapseNavbar()" data-cy="adminReleaseMode">
                            <span>Metodi di rilascio</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" routerLink="/admin/tipologie-autodeploy" routerLinkActive="active" (click)="collapseNavbar()" data-cy="adminAutodeployType">
                            <span>Tipologie di autodeploy</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ng-container>
        </ul>
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" href="{{ appConfiguration.oscatUrl }}">
                    <span class="mx-2">
                        <fa-icon [icon]="['fab','gitlab']"></fa-icon> Torna a Oscat
                    </span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="{{ appConfiguration.guideUrl }}" target="_blank" rel="noopener noreferer">
                    <span>
                        <fa-icon class="mx-2" icon="question-circle"></fa-icon>
                    </span>
                </a>
            </li>
            <li ngbDropdown class="nav-item dropdown pointer" display="dynamic" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="user-menu" data-cy="userMenu">
                    <span><span>{{ this.account?.firstName }}</span><fa-icon class="ms-4 me-2" icon="user"></fa-icon></span>
                </a>
                <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="user-menu">
                    <li>
                        <button class="btn-link dropdown-item" (click)="collapseNavbar()" data-cy="logout" (click)="logout('gitlab')">
                          <span>Logout</span>
                        </button>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</nav>
